import React from 'react';
import { connect } from 'react-redux';
import { safeRedirect } from '@ordermentum/ui-shared/helpers/urls';
import C from '@ordermentum/ui-constants';
import { CardFixedWidth } from '../Card';
import { WhiteBackground } from '../Background';
import { Header, Container, Animation } from './Success.style';
import { RootState } from '../../redux/store';

const imgUrl = `${C.IMAGE_URL}/supplier-animation.gif`;

const SuccessComponent = ({
  notification,
}: {
  notification: { message: string };
}) => {
  if (notification.message === 'Supplier setup finished') {
    window.location.href = safeRedirect('/');
  }
  return (
    <WhiteBackground>
      <CardFixedWidth>
        <Container>
          <Header>Building your platform...</Header>
          <Animation src={imgUrl} alt="" />
        </Container>
      </CardFixedWidth>
    </WhiteBackground>
  );
};

const mapStateToProps = (state: RootState) => ({
  // @ts-expect-error payload does not exist in notifications type
  notification: state.notifications.payload,
});

export const Success = connect(mapStateToProps)(SuccessComponent);
